import * as S from './ProjectArtifactTypes.styles';

import * as React from 'react';

import * as ArtifactUtils from '../util/artifacts';
import {Link} from 'react-router-dom';
import {Header, Loader, Table} from 'semantic-ui-react';
import * as Urls from '../util/urls';
import emptyImg from '../assets/il-no-artifacts.png';
import emptyImg2x from '../assets/il-no-artifacts@2x.png';
import docUrl from '../util/doc_urls';
import {useProjectArtifactsQuery} from '../state/graphql/projectArtifactsQuery';
import makeComp from '../util/profiler';

interface ProjectArtifactsProps {
  entityName: string;
  projectName: string;
  artifactTypeName?: string;
}

const ProjectArtifactTypes = makeComp(
  (props: ProjectArtifactsProps) => {
    const {entityName, projectName} = props;

    const projectArtifactsQuery = useProjectArtifactsQuery({
      entityName,
      projectName,
    });
    if (projectArtifactsQuery.loading) {
      return <Loader />;
    }
    const artifactTypeEdges = projectArtifactsQuery.project.artifactTypes.edges;

    return (
      <div>
        {/* <Link to={Urls.newArtifactType(entityName, projectName)}>*/}
        {/* <div className="button-spacer" /> */}
        {/*</Link> */}
        {artifactTypeEdges.length === 0 ? (
          <NoArtifactsMessage />
        ) : (
          <div className="artifacts-page">
            <Header className="artifacts-page-header">Artifact Types</Header>
            <Table selectable padded>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Name</Table.HeaderCell>
                  <Table.HeaderCell>Description</Table.HeaderCell>
                  <Table.HeaderCell>Count</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {artifactTypeEdges.map(ae => {
                  const artifactType = ae.node;
                  const url = Urls.artifactType({
                    entityName,
                    projectName,
                    artifactTypeName: artifactType.name,
                  });
                  return (
                    <Table.Row key={ae.node.id}>
                      <Table.Cell selectable>
                        <Link to={url}>{artifactType.name}</Link>
                      </Table.Cell>
                      <Table.Cell selectable>
                        <Link to={url}>
                          {
                            ArtifactUtils.parseArtifactTypeDescription(
                              artifactType.description
                            ).description
                          }
                        </Link>
                      </Table.Cell>
                      <Table.Cell selectable>
                        <Link to={url}>
                          {artifactType.artifactSequences.totalCount}
                        </Link>
                      </Table.Cell>
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
          </div>
        )}
      </div>
    );
  },
  {id: 'ProjectArtifactTypes'}
);

const NoArtifactsMessage = makeComp(
  () => {
    const details = (
      <>
        <p>Use artifacts to capture your pipeline steps and model lineage.</p>
        <p>
          <a href={docUrl.artifacts} target="_blank" rel="noopener noreferrer">
            See the docs {'\u2192'}
          </a>
        </p>
      </>
    );
    return (
      <S.EmptyWatermark
        imageSource={emptyImg}
        imageSource2x={emptyImg2x}
        header="Track datasets and model versions."
        details={details}
      />
    );
  },
  {id: 'NoArtifactsMessage'}
);
export default ProjectArtifactTypes;
